import { useContext } from 'react';

import { ErrorContext, type ErrorContextType } from './errorContextValue';

export const useError = (): ErrorContextType => {
  const context = useContext(ErrorContext);

  if (!context) {
    throw new Error('useError must be used within ErrorProvider');
  }

  return context;
};
